import {CountUp} from 'countup.js';

document.addEventListener(
	'DOMContentLoaded',
	function () {

		const components = document.querySelectorAll('.cirrus-stats');

		components.forEach(
			(component) => {

				const stats = component.querySelectorAll('[data-name="stat"]');

				stats.forEach(
					(stat) => {

						const value = parseInt(stat.textContent.replace(/,/g, ''), 10);

						const options = {
							enableScrollSpy: true,
							scrollSpyOnce: true
						};

						new CountUp(stat, value, options);

					}
				)

			}
		);

	}
);